import { BLACK, BLACK_700, BLACK_800, BLACK_900, BLUE_200, BLUE_600, LILAC_200, LILAC_400, GREEN_200, GREEN_600, tokens, WHITE } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getThemeColors = ingressCardTheme => {
  if (ingressCardTheme == 'green') {
    return {
      cardBackgroundColor: GREEN_200,
      iconBgColor: GREEN_600,
      iconColor: WHITE,
      titleColor: BLACK_900,
      descColor: BLACK_800
    };
  }
  if (ingressCardTheme == 'blue') {
    return {
      cardBackgroundColor: BLUE_200,
      iconBgColor: BLUE_600,
      iconColor: WHITE,
      titleColor: BLACK_900,
      descColor: BLACK_800
    };
  }
  return {
    cardBackgroundColor: LILAC_200,
    iconBgColor: LILAC_400,
    iconColor: BLACK,
    titleColor: BLACK_900,
    descColor: BLACK_700
  };
};
export var getIngressCardWidgetStyles = (props, isLargeScreen) => {
  var type = props.type;
  var _tokens$spacing = tokens.spacing,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_14 = _tokens$spacing.SPACING_14,
    SPACING_16 = _tokens$spacing.SPACING_16;
  var descMarginTop = type == 'strip' ? isLargeScreen ? SPACING_8 : SPACING_4 : SPACING_4;
  var actionMarginTop = type == 'compact' ? isLargeScreen ? SPACING_8 : SPACING_4 : isLargeScreen ? SPACING_8 : SPACING_14;
  var safeSpacer = isLargeScreen ? SPACING_14 : SPACING_8;
  return StyleSheet.create({
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    containerPadding: {
      paddingHorizontal: type == 'comfortable' ? SPACING_16 : isLargeScreen ? SPACING_16 : SPACING_12,
      paddingVertical: type == 'comfortable' ? SPACING_16 : isLargeScreen ? SPACING_16 : SPACING_8
    },
    desc: {
      marginTop: descMarginTop
    },
    iconImage: type == 'comfortable' ? {
      marginLeft: SPACING_14,
      flexShrink: 0
    } : {
      marginRight: safeSpacer,
      flexShrink: 0
    },
    content: {
      flex: 1,
      overflow: 'hidden',
      alignSelf: 'center'
    },
    actionItems: {
      flexShrink: 0,
      marginLeft: safeSpacer
    },
    chevronItem: {
      flexShrink: 0,
      marginLeft: isLargeScreen ? SPACING_14 : SPACING_4
    },
    actionDefault: {
      marginTop: actionMarginTop
    }
  });
};
export var getScoreCardStyles = () => {
  var _tokens$spacing2 = tokens.spacing,
    SPACING_16 = _tokens$spacing2.SPACING_16,
    SPACING_18 = _tokens$spacing2.SPACING_18;
  return StyleSheet.create({
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1
    },
    textContainer: {
      position: 'absolute',
      left: SPACING_16,
      top: SPACING_18
    }
  });
};